module.exports = "<router-outlet></router-outlet>\n<app-net-info></app-net-info>\n"